<div cdkScrollable class="room-type-calendar overflow-y-auto">
  <nz-tabset nzSize="large">
    <nz-tab [nzTitle]="'property-calendar_html_tab_日历' | translate">
      <ng-template nz-tab>
        <host-single-rt-status-calendar-v2 [id]="id"></host-single-rt-status-calendar-v2>
        <!-- <div>
          <host-hostex-status [houseTypeId]="id"></host-hostex-status>
        </div> -->
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="'property-calendar_html_tab_价格日历' | translate">
      <ng-template nz-tab>
        <ng-container *ngIf="hasThirdpartyAccount && detail?.relation_platform?.length; else empty">
          <host-single-price-calendar-v2 type="type" [id]="id"></host-single-price-calendar-v2>
        </ng-container>
        <ng-template #empty>
          <div class="v4-layout-empty my-[50px]">
            <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
            <div class="v4-layout-empty-content">
              <div class="v4-layout-empty-title">{{ 'house.house_type_no_channel_account_info' | translate }}</div>
              <div class="v4-layout-empty-desc">{{ 'house.add_account_please' | translate }}</div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
